module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Qué es el gasto?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Qué es"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" el gasto?")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Qué es el gasto?',
      "videoEmbed": "ADMINISTRACIONDINERO27QueEsElGasto.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 340,
      "imaSrc": "contenido/diapositiva_28",
      "imaAlt": "Billetera abierta y sin dinero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("\n        Es la "), _c('strong', [_vm._v("salida de dinero")]), _vm._v(" que permite a una persona adquirir un artículo o servicio. \n        "), _c('strong', [_vm._v("Comprar")]), _vm._v(" alimentos, ropa, muebles, carro, pagar matrículas o arriendos, entre otros, \n        son considerados gastos. \n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-577cee60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-27.vue
// module id = 998
// module chunks = 1